import { FC, PropsWithChildren } from 'react';

type Props = {
	className?: string;
};

const GuyanaFlagIcon: FC<PropsWithChildren<Props>> = ({ className }) => {
	return (
		<svg
			width='20'
			height='14'
			viewBox='0 0 20 14'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={`${className}`}>
			<rect
				width='20'
				height='14'
				rx='2'
				fill='white'
			/>
			<mask
				id='mask0_2332_14871'
				style={{ maskType: 'luminance' }}
				maskUnits='userSpaceOnUse'
				x='0'
				y='0'
				width='20'
				height='14'>
				<rect
					width='20'
					height='14'
					rx='2'
					fill='white'
				/>
			</mask>
			<g mask='url(#mask0_2332_14871)'>
				<rect
					width='20'
					height='14'
					fill='#08C55F'
				/>
				<path
					d='M-0.286458 13.3333V0.666667H-0.106873L19.2809 7L-0.106873 13.3333H-0.286458Z'
					fill='#FFD831'
					stroke='white'
					strokeWidth='1.33333'
				/>
				<path
					d='M9.71371 7L-0.195589 13.3333H-0.286458V0.666667H-0.195589L9.71371 7Z'
					fill='#E92034'
					stroke='#262626'
					strokeWidth='1.33333'
				/>
			</g>
		</svg>
	);
};

export default GuyanaFlagIcon;
